<style lang="stylus" scoped>
@import '../../cardMap/cardMap.stylus';

.title {
  color: #999999;
  font-size: 14px;
}

span {
  margin-right: 15px;
  border-bottom: 3px solid transparent;
  color: #999999;
  display: inline-block;
  height: auto;
  line-height: 2;
  cursor: pointer;
}

span.active {
  border-color: #336CAF;
  color: #326DAF;
}

div.title {
  position: relative;
  padding-top: 40px;
}

em.title {
  position: absolute;
  top: 0px;
  left: -10px;
  color: #999999;
  font-size: 14px;
  font-weight: 400;
  font-style: normal;
}

.title span {
  font-weight: 600;
  font-size: 16px;
  margin-left: -10px;
  margin-right: 37px;
}
</style>
<template>
  <div class="title">
    <em class="title">快速选择时间</em>
    <span
      v-for="(tit, index) in titleArr"
      :key="index"
      :class="{'active':index == (tab - 2)}"
      @click="change(index)"
    >{{tit.title}}</span>
  </div>
</template>
<script>
export default {
  data() {
    return {
      titleArr: [
        {
          title: '昨日数据'
        },
        {
          title: '本月数据'
        },
        {
          title: '本季度数据'
        },
        {
          title: '本年度数据'
        },
        {
          title: '历史累计数据'
        }
      ]
      //tab:  1 指定时间 2 昨日数据 3 本月数据 4 本季度数据 5 本年度数据 6 历史累计数据
    }
  },
  computed: {},
  props: {
    changeType: {
      type: Function
    },
    tab: {
      type: String,
      default: '2'
    }
  },
  methods: {
    change(index) {
      this.changeType(index + 2 + '')
      //this.tab = index
    }
  }
}
</script>

